import { useNotificationContext } from '@context/NotificationContext';
import { Popover } from '@onsolve/onsolve-ui-components';
import React, { useEffect, useRef, useState } from 'react';
import { NotificationButton } from './NotificationButton/NotificationButton';
import { NotificationList } from './NotificationList/NotificationList';
import styles from './Notifications.module.scss';
import NotificationSettings from './NotificationSettings/NotificationSettings';
import jwtService from '@services/jwt.service';
export const Notifications = () => {
    const popoverRef = useRef(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [isSettingsActive, setIsSettingsActive] = useState(false);
    const { announcements, getUserAnnouncements, getEmails, unreadCount, userTimeZone, getTimeZone } = useNotificationContext();
    const userUuid = jwtService.getUserUuid();
    useEffect(() => {
        getUserAnnouncements(userUuid);
        getEmails(userUuid);
        getTimeZone();
    }, [userUuid]);
    useEffect(() => {
        popoverRef.current?.focus();
    }, [isSettingsActive]);
    const handleSettingsClick = () => setIsSettingsActive((prevIsSettingsActive) => !prevIsSettingsActive);
    const toggleNotifications = (event) => {
        event?.stopPropagation();
        setIsPopoverOpen(!isPopoverOpen);
        setIsSettingsActive(false);
    };
    const targetId = 'notifications';
    return (<>
            <NotificationButton id={targetId} count={unreadCount} handleTogglePopover={toggleNotifications} ariaLabel={`open ${unreadCount} notifications`}/>
            <Popover className={styles.notificationPopover} innerClassName={styles.innerPopover} innerRef={popoverRef} target={targetId} isOpen={isPopoverOpen} onClose={toggleNotifications} placement="bottom-end" shouldFocus hideArrow>
                {isSettingsActive ? (<NotificationSettings userUuid={userUuid} handleSettingsClick={handleSettingsClick}/>) : (<NotificationList id={targetId} data={announcements} handleTogglePopover={toggleNotifications} handleSettingsClick={handleSettingsClick} userTimeZone={userTimeZone}/>)}
            </Popover>
        </>);
};
